import script from "./NotificationEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationEntity.vue?vue&type=script&setup=true&lang=js"

import "./NotificationEntity.vue?vue&type=style&index=0&id=d40bbbf2&lang=scss&scoped=true"
import "./NotificationEntity.vue?vue&type=style&index=1&id=d40bbbf2&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d40bbbf2"]])

export default __exports__